let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("dWaws"), load("cTnv7")]).then(() => parcelRequire('gRLhf'));